import { ViewChild, ViewContainerRef, ComponentFactoryResolver, Component, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { BaseComponent } from '../../../base.component';
import { RequiredActionTypes } from '../../../shared/models';
import { RequiredActionService } from '../../../shared/required-action.service';
import { OnsiteRecommendationApprovalComponent } from './onsite-recommendation-approval/onsite-recommendation-approval.component';
import { ImplementOnsiteBlogComponent } from './implement-onsite-blog/implement-onsite-blog.component';
import { OnsiteBlogApprovalComponent } from './onsite-blog-approval/onsite-blog-approval.component';
import { WebsiteAccessComponent } from './website-access/website-access.component';
import { SeoContentSurveyComponent } from './seo-content-survey/seo-content-survey.component';
import { PageCreationApprovalComponent } from './page-creation-approval/page-creation-approval.component';
import { PageOptimizationApprovalComponent } from './page-optimization-approval/page-optimization-approval.component';
import { takeUntil } from 'rxjs/operators';

const componentsRegistry: { [Type: number]: any; } = {
  [RequiredActionTypes.OnsiteRecommendationApproval]: OnsiteRecommendationApprovalComponent,
  [RequiredActionTypes.OnsiteBlogApproval]: OnsiteBlogApprovalComponent,
  [RequiredActionTypes.ImplementOnsiteBlog]: ImplementOnsiteBlogComponent,
  [RequiredActionTypes.WebsiteAccess]: WebsiteAccessComponent,
  [RequiredActionTypes.SeoContentSurvey]: SeoContentSurveyComponent,
  [RequiredActionTypes.PageCreationApproval]: PageCreationApprovalComponent,
  [RequiredActionTypes.PageOptimizationApproval]: PageOptimizationApprovalComponent
};

@Component({
  selector: 'app-required-actions',
  templateUrl: './required-actions.component.html',
  styleUrls: ['./required-actions.component.css']
})
export class RequiredActionsComponent extends BaseComponent implements AfterViewInit {
  @ViewChild('requiredActionContent', { read: ViewContainerRef }) requiredActionContent: ViewContainerRef;

  public showRequiredActions: boolean;

  constructor(private requiredActionService: RequiredActionService, private componentFactoryResolver: ComponentFactoryResolver,
    private changeDetectorRef: ChangeDetectorRef) {
    super();
    this.showRequiredActions = true;
  }

  ngAfterViewInit() {
    this.requiredActionService.requiredActions
      .pipe(
        takeUntil(this.unsubscribe)
      )
      .subscribe(requiredActions => {
        this.showRequiredActions = requiredActions && requiredActions.length > 0;
        if (this.requiredActionContent) {
          this.requiredActionContent.clear();

          for (const requiredAction of requiredActions) {
            const componentFactory: any = this.componentFactoryResolver.resolveComponentFactory(componentsRegistry[requiredAction.type]);
            const instance: any = this.requiredActionContent.createComponent(componentFactory);
            instance.instance.requiredAction = requiredAction;
          }
          this.changeDetectorRef.detectChanges();
        }
      });
    this.requiredActionService.loadRequiredActions();
  }
}
